module.exports = "/fonts/fa-solid-900.ttf?2aae7c212ce9c344ede6369768d4bcca";